export const getDetailsByRoom = (details = []) =>
  details.reduce((rooms, item = {}) => {
    const amount = Number(item.amount);
    const length = Number.isFinite(amount) && amount > 0 ? amount : 1;
    const offset = rooms.length;

    return [
      ...rooms,
      ...Array.from({ length }, (_, index) => ({
        ...item,
        amount: 1,
        detailIndex: offset + index,
      })),
    ];
  }, []);
